"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author siranush.avetisyan
 * @since 8/28/17.
 */
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_lock_service_client_js_1 = require("@synisys/idm-lock-service-client-js");
var service_1 = require("../api/service");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
/**
 * DE Lock Guard for locking DE and navigating to error page.
 */
var LockGuard = /** @class */ (function () {
    function LockGuard(_deService, _router, _lockService, _authenticationService) {
        this._deService = _deService;
        this._router = _router;
        this._lockService = _lockService;
        this._authenticationService = _authenticationService;
        this.LOCK_ERROR_URL = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/", "/", ""], ["", "/", "/", ""])), 'lockErrorPage', 'entityInstanceId', 'userId');
    }
    /**
     * This method check if DE already locked by another user then navigating to lock error page,
     * otherwise add lock for DE.
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<boolean>}
     */
    LockGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var entityInstanceId = route.params.instanceId;
        var lockField = route.data.lockField;
        var systemName = route.data.systemName;
        var lockErrorPage = route.data.lockErrorPage;
        var queryParams = route.data.queryParams;
        var mainEntity$ = this._deService.loadEntityByInstanceId(systemName, entityInstanceId);
        var userData$ = this._authenticationService.getUserData();
        var lockData$ = this._lockService.getLock(systemName, entityInstanceId);
        return zip_1.zip(userData$, mainEntity$).pipe(operators_1.switchMap(function (data) {
            var userData = data[0];
            var mainEntity = data[1];
            return lockData$.pipe(operators_1.switchMap(function (lockData) {
                var currentUserId = +userData.userId;
                if (lockData.getIsLocked() &&
                    lockData.userId !== currentUserId) {
                    var url = _this.LOCK_ERROR_URL.replaceTemplate({
                        entityInstanceId: entityInstanceId.toString(),
                        lockErrorPage: lockErrorPage,
                        userId: lockData.userId.toString(),
                    });
                    _this._router.navigateByUrl(url);
                    return of_1.of(false);
                }
                else if (lockData.getIsLocked() &&
                    lockData.userId === currentUserId) {
                    // no need for add lock if the current user is same as locker user
                    return of_1.of(true);
                }
                else {
                    return _this._lockService
                        .addLock(systemName, entityInstanceId, mainEntity.getProperty(lockField)
                        .value)
                        .pipe(operators_1.map(function () {
                        return true;
                    }));
                }
            }), operators_1.catchError(function (error) {
                var url = _this.LOCK_ERROR_URL.replaceTemplate({
                    entityInstanceId: entityInstanceId.toString(),
                    lockErrorPage: lockErrorPage,
                    userId: null,
                });
                if (!queryParams) {
                    _this._router.navigateByUrl(url);
                }
                else {
                    _this._router.navigate([url], { queryParams: queryParams });
                }
                return of_1.of(false);
            }));
        }));
    };
    LockGuard = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [service_1.DeService,
            router_1.Router,
            idm_lock_service_client_js_1.LockingService,
            idm_authentication_client_js_1.AuthenticationService])
    ], LockGuard);
    return LockGuard;
}());
exports.LockGuard = LockGuard;
var templateObject_1;
//# sourceMappingURL=lock.guard.js.map